import { Project } from 'types';
import { GROUP_TYPE } from 'utils/constants';
import { QUERY_PARAM } from 'utils/constants/QueryParameters';

export const APP_ROUTES = {
  COMPANY_SEARCH_PAGE: '/companies',
  DASHBOARD: '/dashboard',
  DASHBOARD_PROJECT_GROUPS: '/dashboard/projects',
  DASHBOARD_COMPANY_GROUPS: '/dashboard/companies',
};

type TRedirectProps = {
  coordinates?: string;
  zoom?: number;
  groupId?: number;
  regionCode?: string;
  stateCode?: string;
};

export const buildProjectMapURLWithParams = ({
  coordinates,
  zoom,
  groupId,
  regionCode,
  stateCode,
}: TRedirectProps) => {
  const params = new URLSearchParams();

  if (coordinates) {
    params.append(QUERY_PARAM.coordinates, coordinates);
  }
  if (zoom) {
    params.append(QUERY_PARAM.zoom, zoom.toString());
  }
  if (groupId) {
    params.append(QUERY_PARAM.dashboardSelectedGroup, groupId.toString());
  }
  if (regionCode) {
    params.append(QUERY_PARAM.regionCode, regionCode);
  }
  if (stateCode) {
    params.append(QUERY_PARAM.stateCode, stateCode);
  }

  const queryString = params.toString();

  return `/projects?${queryString}`;
};

export const cloneSavedSearchUrl = (savedSearchId: string | number) => {
  return `/saved-search/new/edit?clone=${savedSearchId}`;
};

export const pdpUrl = ({
  projectSlug,
  documentTypeCode,
  documentId,
}: {
  projectSlug: Project['slug'];
  documentTypeCode?: string | null;
  documentId?: string | null;
}) => {
  const params = new URLSearchParams();
  if (documentTypeCode) {
    params.append(QUERY_PARAM.documentType, documentTypeCode);
  }
  if (documentId) {
    params.append(QUERY_PARAM.documentId, documentId);
  }
  const queryString = params.toString();

  return `/projects/${projectSlug}?${queryString}`;
};

export const ddpUrl = (documentId: string) => {
  const params = new URLSearchParams();
  params.append(QUERY_PARAM.isDocumentView, 'true');

  const queryString = params.toString();

  return `/projects/${documentId}?${queryString}`;
};

export const printPDPUrl = (projectSlug: Project['slug']) => {
  return `/projects/${projectSlug}/print`;
};

export const printDDPUrl = (documentId: string) => {
  const params = new URLSearchParams();
  params.append(QUERY_PARAM.isDocumentView, 'true');

  const queryString = params.toString();

  return `/projects/${documentId}/print?${queryString}`;
};

export const companyDetailPageUrl = (companyUUID: string) => {
  return `/companies/${companyUUID}`;
};

export const buildDashboardURLWithParams = ({
  groupId,
  groupType,
}: {
  groupId?: number;
  groupType: GROUP_TYPE;
}) => {
  const params = new URLSearchParams();
  if (groupId) {
    params.append(QUERY_PARAM.dashboardSelectedGroup, groupId.toString());
  }

  const queryString = params.toString();

  const type = groupType === GROUP_TYPE.COMPANY ? 'companies' : 'projects';

  return `/dashboard/${type}?${queryString}`;
};

export const savedSearchEditURL = (groupId: number) => {
  return `/saved-search/${groupId}/edit`;
};
